import { CardItem } from 'src/app/components/Elements/Card';
import DeliveryWindow, { computeTimeRange } from 'src/app/components/Models/DeliveryWindow/container';
import type { DeliveryWindow as DeliveryWindowType } from 'src/app/types';
import { theme } from 'src/styles/theme';

const getTextColor = (isWindowAvailable: boolean, isWindowSelected: boolean): string => {
  if (isWindowSelected && isWindowAvailable) return theme.colors.white;
  if (isWindowAvailable) return theme.colors.capsuleGreen60;
  // If window is unavailable
  return theme.colors.capsuleGray10;
};

const isDeliveryWindowAvailable = (deliveryWindow: DeliveryWindowType): boolean => deliveryWindow?.isAvailable;

const checkShouldShowDivider = (
  nextWindow: DeliveryWindowType,
  activeDeliveryWindowId: string | null,
  isWindowAvailable: boolean
) => {
  const isNextWindowAvailable = isDeliveryWindowAvailable(nextWindow);
  const isNextWindowSelected = activeDeliveryWindowId === nextWindow?.id;
  const shouldShowDivider = isWindowAvailable === isNextWindowAvailable && !isNextWindowSelected;
  return shouldShowDivider;
};

interface DeliveryWindowItemProps {
  deliveryWindow: DeliveryWindowType;
  nextWindow: DeliveryWindowType;
  activeDeliveryWindowId: string | null;
  handleClick: (deliveryWindow: DeliveryWindowType) => Promise<void>;
}

export const DeliveryWindowItem = ({
  deliveryWindow,
  nextWindow,
  activeDeliveryWindowId,
  handleClick,
}: DeliveryWindowItemProps) => {
  const isWindowSelected = activeDeliveryWindowId === deliveryWindow.id;
  const isWindowAvailable = isDeliveryWindowAvailable(deliveryWindow);
  const shouldShowDivider = checkShouldShowDivider(nextWindow, activeDeliveryWindowId, isWindowAvailable);
  const textColor = getTextColor(isWindowAvailable, isWindowSelected);

  const selectDeliveryWindow = () => handleClick(deliveryWindow);

  return (
    <CardItem
      key={deliveryWindow.id}
      tag="a"
      href={isWindowAvailable ? '#' : undefined}
      onClick={isWindowAvailable ? selectDeliveryWindow : undefined}
      highlighted={isWindowSelected && isWindowAvailable}
      inactive={!isWindowAvailable}
      data-cy="deliveryWindow"
      noDivider={!shouldShowDivider}
      aria-label={`Free Delivery between ${computeTimeRange(deliveryWindow, false)}`}
    >
      <DeliveryWindow isWindowAvailable={isWindowAvailable} textColor={textColor} deliveryWindow={deliveryWindow} />
    </CardItem>
  );
};
